import { cn } from "@eisox/design-system";

import { Tooltip } from "~/components/tooltip";

import { Direction, Position, type Component } from "../types";
import { PressureSwitch } from "./pressure-switch";

interface FilterProps extends Component {
  defect: boolean;
  label: string;
}

const Filter: React.FC<FilterProps> = ({ defect, label, position = Position.TOP, direction = Direction.RIGHT }) => (
  <div
    className={cn(
      "gap-1.25 [&_svg]:mx-2.5 flex w-fit flex-col items-center",
      position === Position.BOTTOM && "flex-col-reverse",
      direction === Direction.LEFT && "[&_svg]:-scale-x-100",
    )}
  >
    <PressureSwitch position={position} defect={defect} />
    <Tooltip content={label}>
      <svg width="28" height="92" viewBox="0 0 28 92" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_24390_42983)">
          <rect width="28" height="92" rx="5" fill="#F3F3F9" />
          <path
            d="M1 23L25.6151 11.9501C26.1469 11.7113 26.1427 10.9548 25.6083 10.722L1 0"
            stroke="#122138"
            strokeWidth="1.34286"
            strokeLinecap="round"
          />
          <path
            d="M1 46L25.6151 34.9501C26.1469 34.7113 26.1427 33.9548 25.6083 33.722L1 23"
            stroke="#122138"
            strokeWidth="1.34286"
            strokeLinecap="round"
          />
          <path
            d="M1 69L25.6151 57.9501C26.1469 57.7113 26.1427 56.9548 25.6083 56.722L1 46"
            stroke="#122138"
            strokeWidth="1.34286"
            strokeLinecap="round"
          />
          <path
            d="M1 92L25.6151 80.9501C26.1469 80.7113 26.1427 79.9548 25.6083 79.722L1 69"
            stroke="#122138"
            strokeWidth="1.34286"
            strokeLinecap="round"
          />
        </g>
        <rect x="0.5" y="0.5" width="27" height="91" rx="4.5" stroke="#122138" />
        <defs>
          <clipPath id="clip0_24390_42983">
            <rect width="28" height="92" rx="5" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Tooltip>
  </div>
);
Filter.displayName = "Filter";

export { Filter };
export type { FilterProps };
